import { BlocksIconSettings } from 'blocks-nextjs/blocks-web-components/components/icon/icons/settings';
import React from 'react';
import { createComponent } from '../../CustomWrapper/CustomWrapper';

export const CatIconSettings = createComponent({ react: React, tagName: 'cat-icon-settings', elementClass: BlocksIconSettings });
